 import ScreenWrapper from '@app/hoc/ScreenWrapper';
import { ThemedText, ThemedView } from '@app/theme';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import LottieView from 'lottie-react-native';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { useEffect } from 'react';
import { getNextStepId } from '@screens/KYCStepper/services/service';
import { cibilCheckStatusAPI } from '@screens/CibilCheckLoadingScreen/services/cibilCheckService';
import { updateUserDetails } from '@store/slices/authSlice';
import {
  checkCustomerEligibilityAPI,
} from '@screens/CheckCustomerEligibility/services/checkCustomerEligibilityService';

export type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'CIBIL_CHECK_LOADING_SCREEN'>;


const CibilCheckLoadingScreen = ({ navigation, route }: ScreenProps) => {
  const { userDetails } = useAppSelector(state => state.auth);

  useEffect(() => {
    const checkCibilStatus = async () => {
      const applicationId = userDetails?.linkedApplications?.[0]?.applicationId;
      const cibilCheckResponse = await cibilCheckStatusAPI({ applicationId });
      const nextStepId = cibilCheckResponse?.data?.updatedApplicationObj?.currentStepId;

      try {
        if (nextStepId && (nextStepId !== 'CIBIL_CHECK_LOADING_SCREEN' && nextStepId !== 'CIBIL_CHECK')) {
          clearInterval(intervalId)
          navigation.reset({
            index: 0,
            routes: [{ name: nextStepId }],
          });
        }
      } catch (error) {
        console.log('Cibil check error', error);
      }
    };

    checkCibilStatus();
    
    const intervalId = setInterval(checkCibilStatus, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
      <ThemedView flex={1} backgroundColor={'bg-surface-primary'} alignItems={'center'} justifyContent={'center'}>
        <LottieView
          source={require('../../assets/lottie/sand_timer.json')}
          autoPlay={true}
          loop={true}
          style={{ width: 180, height: 180 }}
        />
        <ThemedText variant={'b2r'} color={'text-primary'}>
          Checking your CIBIL score...
        </ThemedText>
      </ThemedView>
    </ScreenWrapper>
  );
};

export default CibilCheckLoadingScreen; 